import { Component, OnInit} from '@angular/core';
/*import { TranslateService } from '@ngx-translate/core';*/
import { SharedService } from '../shared/shared.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  constructor(private sharedService : SharedService) {  
  	//this.sharedService.currentPageName = "Dashboard";
  	this.sharedService.showAgencyInformation = true;
  }
  ngOnInit() {
    this.sharedService.publishCurrentPage('Dashboard');
  }

  ngOnDestroy(){
  	//this.sharedService.currentPageName = "";
  	this.sharedService.showAgencyInformation = false;
  }

}



// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/dashboard/dashboard.component.ts